import { render, staticRenderFns } from "./ProgramacaoFornecedor.vue?vue&type=template&id=32993040"
import script from "./ProgramacaoFornecedor.vue?vue&type=script&lang=js"
export * from "./ProgramacaoFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports